<template>
  <div>
    <!-- Alert: No item found -->
    <!-- <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert> -->

    <template v-if="user">

      <!-- First Row -->
      <b-row class="justify-content-center">
        <b-col
          cols="12"
         
        >
          <user-view-user-info-card :user-data="user" />
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import UserViewUserInfoCard from '@/components/profile/UserViewUserInfoCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    UserViewUserInfoCard,
  },
  computed:{
    ...mapGetters({user: "auth/user"})
  }

  // setup() {
  //   const userData = ref(null)

  //   const USER_APP_STORE_MODULE_NAME = 'app-user'

  //   // Register module
  //   if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

  //   // UnRegister on leave
  //   onUnmounted(() => {
  //     if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
  //   })

  //   store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
  //     .then(response => { userData.value = response.data })
  //     .catch(error => {
  //       if (error.response.status === 404) {
  //         userData.value = undefined
  //       }
  //     })

  //   return {
  //     userData,
  //   }
  // },
}
</script>

<style>

</style>
